/* eslint-disable no-var */
import { memo, useRef, useEffect, useState } from 'react'
import injectSheet, { createUseStyles } from 'react-jss'
import gsap from 'gsap'
import ResizeObserver from 'resize-observer-polyfill'
import Modernizr from '@/vendors/modernizr'
import { createSVG } from '@/utils/svg'
import { theme } from '@/styles/style'

import style from './style'

const useStyles = createUseStyles(style)

const UnderlinedText = ({
  text,
  strokeWidth,
  height,
}) => {
  const $root = useRef()
  const classes = useStyles({ height })
  const observerRef = useRef()
  const [svgLength, setSvgLength] = useState(0)

  /*------------------------------
  Resize observer to solve path lenght issue
  ------------------------------*/
  useEffect(() => {
    if ($root.current) {
      observerRef.current = new ResizeObserver(() => {
        if ($root.current) {
          setSvgLength($root.current.offsetWidth)
        }
      })
      observerRef.current.observe($root.current)
    }
    return () => {
      if ($root.current) observerRef.current.disconnect($root.current)
    }
  }, [$root])

  /*------------------------------
  UseEffect on svgLength
  ------------------------------*/
  useEffect(() => {
    let svg
    if ($root.current && svgLength > 0) {
      svg = createSVG(svgLength, theme.colors[0], strokeWidth, height)
      svg.children[0].style.strokeDasharray = svg.children[0].dataset.width
      svg.children[0].style.strokeDashoffset = svg.children[0].dataset.width
      $root.current.appendChild(svg)
    }
    return () => {
      if ($root.current && svg) $root.current.removeChild(svg)
    }
  }, [svgLength])

  const handleHover = (e) => {
    // const linkWidth = parseInt($root.current.offsetWidth, 10)
    if (e.type === 'mouseenter' && !Modernizr.devicehastouch) {
      gsap.killTweensOf($root.current.children[1]?.children[0])
      gsap.to($root.current.children[1]?.children[0], {
        duration: 0.6,
        strokeDashoffset: 0,
        ease: 'power1.out',
      })
    }
    if (e.type === 'mouseleave' && !Modernizr.devicehastouch) {
      gsap.killTweensOf($root.current.children[1]?.children[0])
      gsap.to($root.current.children[1]?.children[0], {
        duration: 0.5,
        strokeDashoffset: $root.current.children[1]?.children[0].dataset.width,
        ease: 'power1.in',
      })
    }
  }

  return (
    <span
      className={classes.root}
      ref={$root}
      onMouseEnter={(e) => handleHover(e)}
      onMouseLeave={(e) => handleHover(e)}
    >
      <span
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </span>
  )
}

/*------------------------------
Default Props
------------------------------*/
UnderlinedText.defaultProps = {
  text: '',
  strokeWidth: 5,
  height: 30,
}

export default injectSheet(style)(memo(UnderlinedText))
